// Typelizer digest 151953a2f3b10e6181cc779f1aa9d6a7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /learners/students/:student_id/change_wishlists/:change_wishlist_id/publication */
  create: (
    params: { studentId: string | number; changeWishlistId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/students/:student_id/change_wishlists/:change_wishlist_id/publication', params, options),
    method: 'post',
  }),
}
